import React, { useState, useEffect } from "react";
import LayerAdmin from "../LayerAdmin";
import { toast } from "react-toastify";
import ButtonLoader from "../../zamzam/components/ButtonLoader";
import { useNavigate, useParams } from "react-router-dom";
import URL_MAPPING from "../../../routes/constants";
import { addNewPerm, getDropdownsales, getDropdownchannel } from "../api/auth";
import Dropdown from '../components/Dropdown'
import { useLocation } from "react-router-dom";
type SalesOffice = {
  sales_office_id: string;
  name: string;
};
type Channel = {
  channel_id: string;
  name: string;
};

const AddNewTerritory = () => {
  const [formData, setFormData] = useState({
    id: "",
    values: [],
    channelId: [],
  });
  const { id } = useParams();
  const location = useLocation();
  const item = location.state?.item.name;
  
  const [loading, setLoading] = useState(false);
  const [invalidFields, setInvalidFields] = useState<string[]>([]);
  const [values, setValues] = useState<SalesOffice[]>([]);
  const [valuesChannel, setValuesChannel] = useState<Channel[]>([]);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getInputClass = (field: string) =>
    `w-full border px-3 py-2 rounded ${
      invalidFields.includes(field) ? "border-red-500" : ""
    }`;

  const handleChangeDropdown = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      setLoading(true);
      setInvalidFields([]);
      const payload = {
        role_id: id || "",
        sales_office_ids: formData.values,
        channel_ids: formData.channelId,
      };
      const response = await addNewPerm(payload);
      if (!response) {
        toast.error("No data received or malformed response");
        console.warn("No data received or malformed response:", response);
        return;
      }
      toast.success(response?.message);
      setTimeout(() => {
        navigate(URL_MAPPING.AUTH);
      }, 2000);
    } catch (error: any) {
      console.error("Failed to fetch  data:", error);
      if (error?.response?.status === 404) {
        toast.error("Route not found, Please try again later");
      } else if (error?.response?.status === 500) {
        toast.error(error.response.data.detail);
      } else {
        const detail = error?.response?.data?.detail;
        if (Array.isArray(detail)) {
          detail.forEach((err) => toast.error(err.msg));
        } else {
          toast.error(detail?.msg || detail || "An unexpected error occurred.");
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchMappings = async () => {
      try {
        const res = await getDropdownsales();
        if (!res) {
          toast.error("No data received or malformed response");
          console.warn("No data received or malformed response:", res);
          return;
        }
        setValues(res.sales_offices || []);
      } catch (error: any) {
        console.error("Failed to fetch data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(
              detail?.msg || detail || "An unexpected error occurred."
            );
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMappings();
  }, []);

  useEffect(() => {
    const fetchMappings = async () => {
      try {
        const res = await getDropdownchannel();
        if (!res) {
          toast.error("No data received or malformed response");
          console.warn("No data received or malformed response:", res);
          return;
        }

        setValuesChannel(res.channels || []);
      } catch (error: any) {
        console.error("Failed to fetch employee data:", error);
        if (error?.response?.status === 404) {
          toast.error("Route not found, Please try again later");
        } else if (error?.response?.status === 500) {
          toast.error("Error while fetching the employee");
        } else {
          const detail = error?.response?.data?.detail;
          if (Array.isArray(detail)) {
            detail.forEach((err) => toast.error(err.msg));
          } else {
            toast.error(
              detail?.msg || detail || "An unexpected error occurred."
            );
          }
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMappings();
  }, []);

  const options = values.map((office) => ({
    value: office.sales_office_id,
    name: office.name,
  }));

  const channelOptions = valuesChannel.map((channel) => ({
    value: channel.channel_id,
    name: channel.name,
  }));
  return (
    <LayerAdmin>
      <div className="flex items-center px-5 pt-5 gap-3">
        <button
          onClick={() => window.history.back()}
          className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            version="1.1"
            width="10"
            height="10"
            viewBox="0 0 256 256"
            xmlSpace="preserve"
          >
            <g
              style={{
                stroke: "none",
                strokeWidth: 0,
                strokeDasharray: "none",
                strokeLinecap: "butt",
                strokeLinejoin: "miter",
                strokeMiterlimit: 10,
                fill: "none",
                fillRule: "nonzero",
                opacity: 1,
              }}
              transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
            >
              <polygon
                points="20.48,45 59.75,90 69.52,81.48 37.69,45 69.52,8.52 59.75,0 "
                style={{
                  stroke: "none",
                  strokeWidth: 1,
                  strokeDasharray: "none",
                  strokeLinecap: "butt",
                  strokeLinejoin: "miter",
                  strokeMiterlimit: 10,
                  fill: "rgb(0,0,0)",
                  fillRule: "nonzero",
                  opacity: 1,
                }}
                transform="  matrix(1 0 0 1 0 0) "
              />
            </g>
          </svg>
        </button>
        <h3 className="text-xl font-bold text-gray-700">Assign Sales and Channel Ids  </h3>
      </div>
      <form onSubmit={handleSubmit} className="p-4 lg:w-1/3 sm:w-full">
        <div className="my-2">
          <label className="block font-semibold mb-1">Roles Name</label>

          <input
            type="text"
            name="id"
            disabled
            value={item}
            onChange={handleChange}
            className={getInputClass("id")}
            placeholder="Employee Id"
          />
        </div>

        <div className="my-2">
          <label className="block font-semibold mb-1">Select Sales Id *</label>
          {/* <select
  name="values"
  value={formData.values}
  onChange={handleChange}
  className={getInputClass("values")}
>
  <option value="">Sales</option>
  {values.map(({ sales_office_id, name }) => (
    <option key={sales_office_id} value={sales_office_id}>
      {name}
    </option>
  ))}
</select> */}
          <Dropdown
            name="values"
            value={formData.values}
            onChange={handleChangeDropdown}
            options={options}
            className={getInputClass("values")}
            placeholder="Select Sales Office"
            searchable={true}
            multiple={true}
          />
        </div>
        <div className="my-2">
          <label className="block font-semibold mb-1">
            Select Channel Id *
          </label>
          <Dropdown
            name="channelId"
            value={formData.channelId}
            onChange={handleChangeDropdown}
            options={channelOptions}
            className={getInputClass("channelId")}
            placeholder="Select Channel Id"
            searchable={true}
            multiple={true}
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-teal-500 text-white px-6 py-2 rounded hover:bg-teal-600 flex items-center gap-2"
        >
          Assign Permissions {loading && <ButtonLoader />}
        </button>
      </form>
    </LayerAdmin>
  );
};

export default AddNewTerritory;
